'use client';

import React from 'react';
import Image from 'next/image';

import { IResolvedPartners } from '@/src/utils/collections/partners.mapper';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/src/components/ui/carousel';
import { EmailButton } from '@/src/components/ui/EmailButton/EmailButton';

export const Partners = ({
  title,
  additionalInfo,
  partners,
  contact,
}: IResolvedPartners) => {
  return (
    <div
      className={`mx-auto mb-24 mt-4 flex max-w-1200 flex-col items-center gap-5 overflow-hidden lg:flex-row lg:items-start lg:gap-20`}
    >
      <div className={'px-4 lg:px-0'}>
        <div
          className={
            'text-center text-2xl font-semibold lg:text-start lg:text-3xl'
          }
        >
          {title}
        </div>
        <div className={'text-center lg:text-start'}>{additionalInfo}</div>
      </div>
      <Carousel
        opts={{
          align: 'start',
        }}
        className={'ml-4 mt-auto lg:ml-0'}
      >
        <CarouselContent>
          {partners.map((partner, index) => (
            <CarouselItem
              key={partner.icon + '_' + index}
              className={'basis-1/1'}
            >
              <div>
                <Image
                  placeholder={'blur'}
                  blurDataURL={'/static/images/placeholder.webp'}
                  key={partner.icon}
                  src={partner.icon}
                  alt={partner.alt || ''}
                  width={160}
                  height={32}
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      {contact && (
        <EmailButton
          email={contact.email}
          subject={contact.subject}
          text={contact.buttonText}
        />
      )}
    </div>
  );
};
